<ng-container *ngIf="device.isMobile && !device.isTablet">
    <div class="sk-main-cal-mobile">
        <div class="sk-center-content">
            <div class="sk-left-center">
                <ms-skeleton-grid></ms-skeleton-grid>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!device.isMobile || device.isTablet">
    <div Class="sk-live-grid-desk">
        <ms-skeleton-grid></ms-skeleton-grid>
    </div>
</ng-container>
